module.exports = __webpack_public_path__ + "assets/img/00075.0dba4f9a.png";